import { Box, CircularProgress } from "@mui/material";
import TalentInfo from "./EditProfile/TalentInfo";
import { useAuth, useCurrentTalentProfile } from "../../hooks";
import EditForm from "./EditProfile/EditForm";
import { useGetATalent } from "../../services/api/talent.api";

export type TalentFormData = {
  username: string;
  categories: string;
  bio: string;
  profile_image: string | File;
  cover_image: string | File;
  portfolio_links: string[];
  social_links: {
    url: string;
    type: string;
  }[];
  skills: string[];
}


export default function TalentProfileEdit() {
  const { userInfo } = useAuth();
  const { currentProfile } = useCurrentTalentProfile();

  const { data: talent, isLoading } = useGetATalent({
    key: ["talent", currentProfile?.id],
    params: {
      id: Number(currentProfile?.id),
    },
    options: {
      enabled: !!currentProfile?.id,
    },
  });

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" mt={6}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%", position: "relative" }}>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "500px",
          overflow: "hidden",
        }}
      >
        {/* Black Overlay */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 1,
          }}
        />

        {/* Video */}
        <img
          loading="lazy"
          src={talent?.data?.cover_image || "/assets/singer_singing.jpg"}
          alt="talent-image"
          // autoPlay
          // loop
          // muted
          style={{
            width: "100%",
            height: "35rem",
            objectFit: "cover",
            position: "absolute",
            top: 0,
            left: 0,
          }}
        />

        {/* Text Overlay */}
      </Box>
      <Box
        sx={{
          padding: "1.5rem",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <TalentInfo talentInfo={talent?.data!} userInfo={userInfo!} />
        <EditForm talentInfo={talent?.data!} />
      </Box>
    </Box>
  );
}
